const getCommonEnglish = (auto24Domain: string) => ({
    aboutPage: {
        futureSection: {
            description:
                "AUTO24.{{ Country_cctld }} is more than a marketplace - it's a community built on a legacy of trust, customer satisfaction, and automotive excellence. With a focus on helping customers make informed choices, we are redefining how {{ Country_people_indication }}s buy and sell used cars. Join the thousands who've made the switch to smarter car buying.",
            description2:
                'AUTO24.{{ Country_cctld }} - Certified Quality, Guaranteed Confidence',
            title: 'Driving the Future of Used Cars in Africa'
        },
        heroDescription:
            "AUTO24.{{ Country_cctld }} is {{ Country_name }}’s trusted source for certified used cars, proudly leading the continent as the No.1 multi-brand retailer of pre-owned vehicles. Our mission is to transform the car buying experience through quality, transparency, and trust. Whether you're purchasing your first car or upgrading, we provide a platform where confidence meets convenience.",
        heroTitle: 'Where Quality Meets Confidence',
        welcomeToAuto24: 'Welcome to AUTO24',
        whyTrustUsSection: {
            description:
                'We go beyond car sales – we offer complete peace of mind',
            pointsDescription:
                'We go beyond car sales – we offer complete peace of mind.',
            pointsDescription1:
                'Every car is rigorously checked by certified technicians, from engine health to interior quality.',
            pointsDescription2a:
                '5-Day Refund Policy – Not satisfied? Return it within 5 days.',
            pointsDescription2b:
                '6-Month Warranty – Standard on all certified vehicles.',
            pointsDescription2c:
                '1-Year Insurance + Maintenance Packages – Drive worry-free from day one.',
            pointsDescription3:
                'All vehicle history and ownership papers are fully vetted for legal and mechanical integrity.',
            pointsDescription4:
                'Seamless process to sell or swap your vehicle with fair valuations.',
            pointsTitle: 'Why Thousands Trust AUTO24',
            pointsTitle1: '120-Point Vehicle Inspection',
            pointsTitle2: 'Customer-First Benefits',
            pointsTitle3: 'Verified Documentation',
            pointsTitle4: 'Quick & Secure Trade-Ins',
            title: 'Why Thousands Trust AUTO24'
        }
    },
    browseCars: {
        buttonText: 'Browse All Cars',
        description:
            'Browse {country_name}’s top-rated certified used cars — quality-inspected, fully insured, a nd ready for the road.',
        title: 'Find Your Perfect Ride Today'
    },
    and: 'and',
    buy: 'Buy',
    sell: 'Sell',
    send: 'Send',
    finance: 'Finance',
    about: 'About',
    blogs: 'Blogs',
    blog: 'Blog',
    tools: 'Tools',
    callUsAt: 'Call us at',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    or: 'or',
    insure: 'Insure',
    enteremailAddress: 'Enter Email Address',
    enterPassword: 'Enter Password',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot Password',
    carsAvailable: 'Cars Available Now',
    carAvailable: 'Car Available Now',
    cancel: 'Cancel',
    enterFullName: 'Enter Full Name',
    byClickingXButton: 'By clicking {{name}} Button, you agree to our',
    termOfUse: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
    alreadyhaveanAccount: 'Already have an account?',
    howItWorks: 'How It Works',
    howtoBuy: 'How to Buy',
    howtoSell: 'How to Sell',
    exploreBlogs: 'Explore Blogs',
    car: 'Car',
    search: 'Search',
    Certified: 'Certified',
    Inspected: 'Inspected',
    petrol: 'Petrol',
    automatic: 'Automatic',
    pleaseprovideusyourdetails: 'Please provide us your details',
    pleaseprovideusyourcardetails: 'Please provide us your car details',
    desiredPleaseprovideusyourcardetails:
        'Please provide us your desired car details, select at least one.',
    phonenumberisnotvalid: 'Phone number is not valid',
    internalError: 'Internal error. Please try again or contact us.',
    knowaboutyourcarbetterandgetevaluation:
        'Know about your car better and get valuation for a better deal.',
    cardetailssendSuccessfully: 'Car details sent sucessfully',
    thanyouforprovidingusdetail:
        'Thank you for provding us the details. We will give you a call back soon.',
    selectbrand: 'Select a brand',
    selectcountry: 'Select country',
    enterMileage: 'Enter Mileage',
    minMileage: 'Minimum Mileage',
    maxMileage: 'Maximum Mileage',
    selectmodel: 'Select a model',
    selectYear: 'Select Year',
    selectorenterbrand: 'Select a brand',
    selectorentermodel: 'Select a model',
    selectorenterbodyType: 'Select or enter a body type',
    brand: 'Brand',
    model: 'Model',
    modelYear: 'Model Year',
    selectFuelType: 'Select Fuel Type',
    selectACondition: 'Select a Condition',
    phoneNumber: 'Phone Number',
    loanTitle: 'We Provide You The Best Offer, get 10% Interest',
    loanHappyCusSubtitle:
        // 'We do care about our customers and their happiness which encourage us to provide more services',
        'You can trust us like these happy clients! Check our reviews!',
    loanButton: 'Calculate My Loan',
    calculateButton: 'Calculate',
    blogTitle: 'Have A Look Before Buying Car',
    blogSubtitle:
        'These are the thing that you must know before buying any kind of car',
    viewAllCars: 'View All Cars',
    viewAllResultsFor: 'View All Results For',
    availableNowOn: 'Available Now On',
    account: 'Account',
    myAccount: 'My Account',
    ourBrands: 'Our Brands',
    contactUs: 'Contact us',
    contactInformation: 'Contact Information',
    aboutUs: 'About us',
    addressLine: 'Address Line',
    contact: 'Contact',
    allcarshavebeenthoroughlyinspectedandreconditionedHowweguaranteecarquality:
        ' All our cars have been inspected and reconditioned meticulously by our experts',
    imInterested: "I'm interested",
    buyOnline: 'Buy Online',
    downPayment: 'Down Payment',
    hotDeal: 'Hot deal',
    lowPrice: 'Low price',
    likeNew: 'Like new',
    moneybackSubtitle: 'You don’t like the car? We refund you',
    warrentyTitle: '6 months warranty',
    warrentySubtitle:
        'Extendable to 12 months on engine, gearbox and powertrain',
    inspectionPointsSubtitle:
        'Inspected by our team of auto experts on all angles',
    roadSideAssistanceTitle: '1 year assistance',
    roadSideAssistanceSubtitle:
        'Roadside assistance included on all our vehicles, for one year',
    deliveryTitle: 'Home delivery',
    deliverySubtitle: 'We can deliver your car anywhere in Morocco',
    xDeliverySubtitle: 'We can deliver your car anywhere in {{country}}',
    Summary: 'Summary',
    engine: 'Engine',
    enginePower: 'Engine Power',
    fuelType: 'Fuel Type',
    buildYear: 'Build Year',
    bodyType: 'Body Type',
    numberofkeys: 'Number of keys',
    exteriorColor: 'Exterior Color',
    interiorColor: 'Interior Color',
    driveTrain: 'Drivetrain',
    engineSize: 'Engine size',
    fiscalPower: 'Fiscal power',
    specifications: 'Specifications',
    specification: 'Specification',
    lengthWidthHeight: 'Length,Width & Height',
    weight: 'weight',
    emissionCO2: 'Emission CO2',
    fuelConsumption: 'Fuel Consumption',
    enginepower: 'Engine Power',
    fuelTankCapacity: 'Fuel Tank Capacity',
    'performance&Economy': 'Performance & Economy',
    features: 'Features',
    'weight&Dimensions': 'Weight & Dimensions',
    showMoreFeatures: 'Show More Features',
    showLess: 'Show Less',
    serviceHistory: 'Service History',
    whyAUTO24: 'Why AUTO24',
    whyChooseAuto: 'Why Choose AUTO24?',
    serviceCenter: 'Service Center',
    Kilometers: 'Km',
    lookingForaCarQtellUs: 'Looking For a Car? Tell Us!',
    sellPageTitle: 'Sell Your Car With Two Easy Steps',
    sellPageSubtitle:
        'You can provide details about your car and we will call you back for futher deals.',
    findCarPricePageTitle: 'Find The Price of Your Car',
    findCarPricePageSubtitle:
        'You can provide details about your car and we will call you back for futher deals.',
    whyFinanceYourCarwithAuto24: 'Why Finance Your Car With AUTO24',
    financeSubtitle:
        'We provide you the best financing offers with low interest and downpayments',
    competitiveRates: 'Competitive Rates',
    competitiveDesc: 'APR from 5% (indicative)',
    competitiveDescMA: 'Possibility of free credit under conditions',
    flexiableDuration: 'Flexible Durations',
    flexiableDes: 'Pay for your car in 12 to 72 monthly installments',
    Percent100OnlineApproach: '100% Online Approach',
    Percent100OnlineApproachDesc: 'Sign all you documents at home',
    loanCalculatorTitle: 'Car Loan Calculator',
    loadCalculatorSubtitle:
        'Monthly interest rate may differ as we partner with different finance institutions.',
    interestRate: 'Interest Rate',
    years: 'years',
    ourFinancingPartners: 'Our Finance partner',
    ourInsurePartners: 'Our insurance partner',
    ourPartners: 'Our Partners',
    copyrightfooter: 'Copyright © Africar Group Pty Ltd - All rights reserved',
    insureSubtitle: 'Enjoy the best insurance policy at the best price',
    aboutFinanceSub: 'Here are some of our financing partners',
    selectMileageRange: 'Select Mileage Range',
    selectTransmissionType: 'Transmission Type',
    backToHome: 'Back to Home',
    getACallBack: 'Get a Callback',
    personalDetails: 'Personal Details',
    carDetails: 'Car Details',
    enterCarDetails: 'Enter Car Details',
    ourBrandsSubtitle:
        'We are associated with the top brand car which have won many awards for the best performance',
    ourTeam: 'Our Team',
    findCarPrice: 'Pricing Tool',
    teamMembers: 'Team Members',
    ourTeamSubtitle: 'Know us better through our teams thoughts',
    latestPosts: 'Latest Posts',
    lastestPostSubtitle: 'Here are latest blogs from different users',
    featuredPosts: 'Featured Posts',
    featuredPostSubtitle: 'Here are featured blogs from different users',
    newsLetterTitle: 'Never Miss a <yellow>Story</yellow>',
    newsLetterSubtitle:
        'Subscribe to AUTO24 Blog to stay updated about everything Cars.',
    buySellTitle: 'Are you Ready ?',
    buySellSubtitle:
        'Whether it’s selling your used car or buying your next ride, we can do it all.',
    sellYourCar: 'Sell Your Car',
    buyaCar: 'Buy a Car',
    footerInfo: `${auto24Domain} is a subsidiary of Africar Group Pty Ltd, registered in Ivory Coast under the IDU CI-2022-0027564 O.`,
    FAQ: 'FAQ',
    buyCars: 'Buy Cars',
    sellCars: 'Sell Cars',
    categories: 'Categories',
    topStories: 'Top Stories',
    pleaseInputYourPassword: 'Please input your password!',
    donthaveanaccount: "Don't have an account",
    resetPassword: 'Reset Password',
    editProfile: 'Edit Profile',
    createNewPassword: 'Create New Password',
    passwordresetsuccessfully: 'Password reset successfully',
    pleaseInputYourName: 'Please input your Name!',
    pleaseInputYourEmail: 'Please input your Email Address!',
    pleaseInputValidEmail: 'Please input a valid Email Address!',
    pleaseInputYourPhoneNumber: 'Please input your Phone number!',
    maximumXdigitsisallowed: 'Maximum {{X}} digits is allowed',
    minimumXdigit: 'Minimum {{X}} digits is allowed',
    passwordisRequired: 'Password is required!',
    minimum8chars: 'Minimum 8 characters are required',
    usersuccessfullyregistered: 'User successfully registered !',
    shortBio: 'Short Bio',
    Save: 'Save',
    Share: 'Share',
    doyouwantDeleteAccount: 'Do you want to permanently delete your account?',
    delete: 'Delete',
    saveChanges: 'Save Changes?',
    youcanstillchangetheseinformation: 'You can still change these information',
    changessavedsuccessfully: 'Changes saved successfully',
    yourchangessavedsuccessfully: 'Your changes have been saved successfully',
    deleteyourAccount: 'Delete your account ?',
    deleteAccountsubtitile:
        'Once you delete your account your all data will be lost and you cant  get access to your account.',
    accountdeletedsuccessfully: 'Account deleted successfully',
    youcanstillexpolrecarwithouthavinganaccount:
        'You can still explore cars without having an account.',
    logout: 'Logout',
    xInspectionPoints: '{{number}} inspection points',
    xlistingPageResultTitle: '{{number}} Cars Found',
    sortBy: 'Sort By:',
    lowestPriceFirst: 'Lowest Price First',
    highestMileageFirst: 'Highest Mileage First',
    lowestMileageFirst: 'Lowest Mileage First',
    price: 'price',
    mileage: 'Mileage',
    selectBodyType: 'Select Body Type',
    filter: 'Filters',
    moreFilters: 'More Filters',
    color: 'Color',
    transmission: 'Transmission',
    highestPriceFirst: 'Highest Price First',
    provideUsYourDetail: 'Provide Us Your Detail',
    interestcartitle: 'Are You Willing to Buy This Car?',
    interestcarsubtitle:
        'Choose one option, the others will continue to be available in your purchase process',
    bookThisCar: 'Book this car',
    bookThisCarSubtitle:
        'Click here to\nsend us a payment of {{Price}} {{ Currency }}, we block the car for 1 week, just for you',
    scheduleAVisit: 'Schedule a visit',
    scheduleAVisitSubtitle:
        'Visit our store to have a look at your desired car. It still will be available to other buyers',
    popularblog: 'Popular Blogs',
    popularblogSub: 'Here are Popular blogs from different users',
    category: 'Category',
    carOverview: 'Car Overview',
    Detailssentsuccessfully: 'Details sent successfully',
    DetailChangeSubtitle:
        'Thank you for providing us your details. We will give you a call back soon.',
    continue: 'Continue',
    carnotfoundSubtitle:
        'No car is available for selected criteria. Help us with your details and we will help you find the right car!',
    logoutModelTitle: 'Are you sure you want to Logout?',
    french: 'French',
    QuickLinks: 'Quick Links',
    similarResults: 'Similar Results ',
    copyrightInfo: `${auto24Domain} is a subsidiary of Africar Group Pty Ltd, registered under the unique identification number CI-2022-0027564 O in the Republic of Cote d'Ivoire`,
    recentlyAdded: 'Recently Added',
    recentlyAddedSubtitle:
        'Here you can see different cars which has been recently added',
    newCarList: 'New Cars',
    newCarListSubtitle: 'Here you can see different new cars',
    electricCarList: 'Electric Cars',
    electricCarListSubtitle: 'Here you can see different electric cars',
    importedCarList: 'Imported Cars',
    importedCarListSubtitle: 'Here you can see different imported cars',
    cheapestCarList: 'Cars Under {{X}}',
    cheapestCarListSubtitle:
        'Here you can see different cheap cars under {{X}}',
    hereyoucanseedifferentsimilarcars:
        'Here you can see different similar cars',
    vehicleNotFound: {
        title: 'Vehicle Not Found? Let Us Help',
        description:
            "If you couldn't find the exact vehicle you're looking for, don't worry — we've got you covered. Just send us your requirements, and our team will search through our extended inventory and partner network to find the best match for you. We'll get back to you with options tailored to your needs.",
        sendRequirement: 'SEND REQUIREMENT'
    },
    sendRequirement: 'Send Requirement',
    sendRequirementDescription:
        'Let us know your preferences, and our team will work to find the ideal match for you. Submit your request today and get one step closer to driving your dream car.',
    whatsappUrlText: 'Hello! I am interested in this car',
    latestService: 'Latest Service',
    resetSuccessMsg:
        'Now you can sign in with your new password or you can still explore cars',
    bothPasswordMustMatch: 'Both passwords must match',
    mustBeAtleast8Characters: 'Must be at least 8 characters',
    sendResetLink: 'Send Reset Link',
    returnTo: 'Return to',
    enterEmailToGetResetLinkInfo:
        "Enter the email associated with your account and we'll send an email with instruction to reset your password",
    resetPasswordModalTitle: 'Are you sure you want reset your password?',
    yourPasswordChangedSuccessfully:
        'Your password has been changed successfully',
    confirmPassword: 'Confirm Password',
    carViewsXTimes: 'Viewed {{number}} times today',
    shortDescription: 'Short Description',
    carImages: 'Car Images',
    uploadImage: 'Upload Image',
    browse: 'Browse',
    listAnother: 'List Another',
    listCarRequestSentSucessfully: 'List Car Request Sent Successfully',
    basicDetails: 'Basic Details',
    manual: 'Manual',
    postYouHaveLiked: 'Post you have liked',
    enterOldPassword: 'Enter Old Password',
    enterNewPassword: 'New Password',
    enterPrice: 'Enter your Price',
    confirmNewPassword: 'Confirm New Password',
    passwordChangeSuccessfully: 'Password changed successfully',
    phonePlaceholder: 'Enter your mobile number',
    verificationTitle:
        'We have sent you a verification link to you email address',
    viewLink: 'View Link',
    resendingLink: 'Resend Link',
    tokenExpired: 'Your token is expired please create new one',
    tokenExpiredTitle: 'Account Verification Link Expired',
    callBackSubtitle:
        'Enter your name and phone number we’ll get back to you soon',
    provideUsYourDetails: 'Provide us Your Detail',
    diesel: 'Diesel',
    other: 'Other',
    showCars: 'Show Cars',
    accountVerifiedSuccessfully: 'Account verified successfully',
    accountVerifiedSuccessfullySubtitle:
        'Your account has been verified successfully. Do you want to login?',
    engineSound: 'Engine Sound',
    showAllImage: 'Show All Images',
    ourBenefits: 'Our Benefits',
    inspectionPoints: '100+ inspection points by our car experts',
    warranties: '6 months warranty (engine,gearbox and axle)',
    maintenances: `1 year maintenance package with ${auto24Domain}`,
    assistance: '12 months towing and breakdown assistance',
    multiCurrency: 'Multi-currency payment DH, €, $, £',
    moneyBack: '5 days money back guarantee',
    financing: 'Financing ',
    dragAndDrop: 'Drag & drop image or',
    imageFormat: 'Supported formats: JPEG, PNG',
    sellNow: 'Sell Now',
    sellCar: 'Sell Car',
    confirm: 'Confirm',
    didntFindQuestion: 'Didn’t find the question you’re looking for?',
    yourMessage: 'Your Message',
    sendMessage: 'Send Message',
    loanTenure: 'Loan Tenure',
    selectLoanTenure: 'Select Loan Tenure',
    interestInput: 'Enter amount between ({{X}} and {{Y}})',
    months: 'Months',
    from: 'From',
    upto: 'Upto',
    rateOfInterest: 'Rate of Interest',
    tenure: 'Tenure',
    monthlyEmi: 'Monthly EMI',
    loadMore: 'Load More',
    contactSubtitle: 'Have any queries ? You are free to message us.',
    inspector: 'Inspector',
    inspectorSubtitle: 'Ask for an inspector',
    insurance: 'Insurance',
    insuranceSubtitle: 'Ask for best insurance',
    financeSubtitles: 'Ask for best finance',
    diagnostic: 'Diagnostic',
    minPrice: 'Min Price',
    maxPrice: 'Max Price',
    minDistance: 'Min Distance',
    maxDistance: 'Max Distance',
    min: 'Min',
    max: 'Max',
    diagonosticSubtitle: 'Ask for diagnostic',
    VINVerify: 'VIN Verify',
    VINVerifySubtitle: 'Ask for quick VIN verify',
    learnMore: 'Learn More',
    speedRegular: 'Speed Regulator',
    airCondition: 'Air Condition',
    sequential: 'Sequential',
    CDPlayer: 'CD Player',
    reversingCamera: 'Reversing Camera',
    reversingRadar: 'Reversing Radar',
    GPSNavigation: 'GPS Navigation',
    parkAssist: 'Park Assist',
    startAndStop: 'Start and Stop',
    airbag: 'Airbag',
    ABS: 'ABS',
    computer: 'Computer',
    rims: 'Rims',
    sunroof: 'Sun Roof',
    electricMirrors: 'Electric mirrors',
    electricWindows: 'Electric windows',
    dateFirstUse: 'Date first use',
    seats: 'Seats',
    certifiedUsedCars: 'Certified Used Cars',
    certifiedUsedCarsSubtitle: 'Buy used cars with trust and transparency',
    inpectionsPoints: '100 Inspection Points',
    inpectionsPointsSubtitle: 'All our cars have been checked thoroughly',
    refundPolicy: '5 Days Refund Policy',
    refundPolicySubtitle: 'You don’t like it, get refunded!',
    warrentySubtitles: 'Engine, gearbox and powertrain, 6 months warranted',
    excellentCondition: 'Excellent condition',
    goodCondition: 'Good condition',
    averageCondition: 'Average condition',
    damagedCar: 'Damaged car',
    lessThan10: 'Less than 10 000 Km',
    betweenXAndY: 'Between {{X}} and {{Y}} km',
    moreThan100: 'More than 100 000 Km',
    serviceTitle: 'Buying or Selling ? We Can Help You',
    serviceSubtitle:
        'Explore our services and make your car buying / selling experience seamless ',
    verifyAccount: 'Verify Account',
    verifyNumber: 'Verify Number',
    otpVerificationSubtitle:
        'Enter the 5 digit code sent to {{code}} {{number}}',
    otpVerificationEmail: 'Enter the 5 digit code sent to {{email}}',
    didntGetTheCode: 'Didn’t get the code?',
    resendCode: 'Re-send code',
    bluetooth: 'Bluetooth',
    home: 'Home',
    lookingForBestInsurance: 'Looking For The Best Insurance?',
    ourCustomerRepresentativesWillGetBackInTouchWithYou:
        'Our customer representatives will get back in touch with you.',
    upload: 'Upload',
    profileUpload: 'Upload New Picture',
    remove: 'Remove',
    xIsrequired: '{{name}} is required',
    number: 'Number',
    backToCarDetail: 'Back To Detail Page',
    backToTheCarDescription: 'Back to the car description',
    backToTheCarListing: 'Back To Car Listing',
    phoneVerifiedSuccesfully: 'Phone Verified successfully',
    phoneVerifiedSubtitle:
        'Your phone number has been verified successfully. Do you want to login',
    signWithPhone: 'Sign in with Phone',
    signWithEmail: 'Sign in with Email',
    newPriceFrom: 'New Car Price From',
    theySpeakAboutUs: 'They speak about us',
    theySpeakAboutUsSubTitle:
        'A selection of international press leaders speaking about AUTO24',
    carLoanSubTitle: 'Estimated Monthly Repayment',
    carLoanTotalRepayment: 'Total Repayment Amount',
    forgotTokenExpired: 'Password Reset Link is Expired',
    discover: 'Discover the car',
    paperWork: 'Vehicles paperwork are up to date and verified',
    verifyhistory: 'We verify history of all the vehicles we buy',
    buyBack: 'We buy back your old car',
    additionalPhotos: 'Additional Photos',
    inspectionReports: 'Inspection Reports',
    referenceLink: 'Reference Link',
    technicalVisit: 'Technical visit certificate',
    keysPhotos: 'Keys photo',
    seeKeyPhotos: 'See the photo',
    pleaseTryAfterSomeTime: 'Please try after some time',
    favourites: 'Favourites',
    electric: 'Electric',
    autonomy: 'Autonomy',
    productionYear: 'Production Year',
    payWithOtherCurrencytitle: 'Pay in an other currency with AUTO24',
    payWithOtherCurrencySubtitle:
        'With AUTO24, you can pay on one of our international bank accounts in any of the currencies below. Here is the price you would need to transfer.',
    convertedPrice: 'Converted Price',
    favouritesNotFoundSubtitle:
        'You haven’t added any cars to favourites. Explore cars and add your favourites',
    noFavouritesFound: 'No Favourites Found',
    frontCrankOilSeal: 'Front crank oil seal',
    engineOverHaul: 'Engine overhaul',
    rearCrankOilSeal: 'Rear crank oil seal',
    engineTuneUp: 'Engine tune up',
    engineMount: 'Engine Mount',
    oilPanGasket: 'Oil Pan Gasket',
    valveCoverGasket: 'Valve cover gasket',
    oilFilterBracketOring: 'Oil filter bracket oring',
    intakeManifoldGasket: 'Intake Manifold Gasket',
    waterLeak: 'Water leak',
    radiator: 'Radiator',
    engineTimingCoverGasket: 'Engine Timing Cover Gasket',
    waterPump: 'Water Pump',
    belts: 'Belts',
    fuelFilter: 'Fuel Filter',
    airFilter: 'Air Filter',
    underChassis: 'Under Chassis',
    tieRod: 'Tie Rod',
    ballJointLandR: 'Ball Joint L&R',
    idlerArm: 'idler Arm',
    pitmanArm: 'Pitman Arm',
    steeringPump: 'Steering Pump',
    steeringHoses: 'Steering Hoses',
    steeringBox: 'Steering Box',
    steeringRackAndPinion: 'Steering Rack & Pinion',
    frontShockLandR: 'Front Shock L&R',
    rearShockLandR: 'Rear Shock L&R',
    stabilizerLinkage: 'Stabilizer Linkage',
    crossJointPropellerShaft: 'Cross Joint Propeller Shaft',
    upperArmBushing: 'Upper Arm Bushing',
    rearLowerArmBushing: 'Rear Lower Arm Bushing',
    suspensionSpring: 'Suspension Spring',
    breakSystem: 'Break System',
    brakePad: 'Brake Pad',
    brakeDiscRotor: 'Brake Disc Rotor',
    wheelBearing: 'wheel Bearing',
    brakeMasterCLY: 'Brake Master CLY',
    backBooster: 'Back Booster',
    brakeWheelCall: 'Brake Wheel Call',
    handBrakeCable: 'Hand Brake Cable',
    brakeHoses: 'Brake Hoses',
    rearAxlesAndDriveShafts: 'Rear Axles & Drive Shafts',
    frontAxle: 'Front Axle',
    rearAxle: 'Rear Axle',
    axleDifference: 'Axle Difference',
    differenceFrontOrRear: 'Difference Front Or Rear',
    axleSealFrontOrRear: 'Axle Seal Front Or Rear',
    oilPumpGasket: 'Oil Pump Gasket',
    frontOilSeal: 'Front Oil Seal',
    rearOilSeal: 'Rear Oil Seal',
    transmissionMount: 'Transmission Mount',
    gearStickSouta: 'Gear Stick Souta',
    oilCollerPipe: 'Oil Cooler Pipe',
    gearPerformance: 'Gear Performance',
    liquidSystem: 'Liquid System',
    engineOil: 'Engine Oil',
    transmissionOil: 'Transmission Oil',
    brakeFluid: 'Brake Fluid',
    engineCoolant: 'Engine Coolant',
    washerFluid: 'Washer Fluid',
    electricitySystem: 'Electricity System',
    battery: 'Battery',
    alternator: 'Alternator',
    starler: 'Starler',
    lights: 'Lights',
    ac: 'A/C',
    centerLock: 'Center Lock',
    wiperBlades: 'Wiper Blades',
    troubleCode: 'Trouble Code',
    computerCods: 'Computer Cods',
    acCondensor: 'A/C Condenser',
    acRadiator: 'A/C Radiator',
    interior: 'Interior',
    seatAndBelts: 'Seats And Belts',
    interiorControlsAndSwitches: 'Interior Controls And Switches',
    sunRoofAndWindows: 'Sun Roof And Windows',
    fuelAndTemperatureGauge: 'Fuel And Temperature Gauge',
    dashboardAndGauges: 'Dashboard And Gauges',
    radioOrMusicSystem: 'Radio Or Music System',
    sRSAirbags: 'SRS Airbags',
    steeringWheelTiltOrlock: 'Steering Wheel Tilt Or Lock',
    mirrors: 'Mirrors',
    bodyInspection: 'Body Inspection',
    inspectionDate: 'Inspection Date',
    carInspectionReport: 'Car Inspection Report',
    showPicture: 'Show Picture',
    pageNotFound: 'Page Not Found',
    pageRemoved: 'This page doesn’t exist or was removed!',
    askQuestionOnWhatsapp: 'Questions? Ask us on whatsapp!',
    whatsappsPlaceholder: 'Ask anything!',
    customerSupport: 'Customer Support',
    needHelpChatWithUs: 'Need Help? Chat with us on Whatsapp',
    instaTitle: 'Follow us on Instagram',
    instaSubTitle:
        'Get updated with our latest offers, products and news instantly!',
    questionSentSuccessfully: 'Question Sent Successfully',
    questionSentSuccessfullySubtitle:
        'Your question has been sent successfully. We will get back to you for your answer',
    unSubscribeMessage:
        'You have been successfully unsubscribed from the Auto24 Blogs.',
    numberMustBeUnique: 'Number must be unique',
    pleaseEnterFullName: 'Please Enter Full Name',
    saving: 'Saving',
    sending: 'Sending',
    signingIn: 'Signing In',
    signingUp: 'Signing Up',
    loggingout: 'Logging out',
    deleting: 'Deleting',
    querySubmittedSuccessfully: 'Query submitted successfully',
    somethingWentWrong: 'Something went wrong!',
    removedFromWishlist: 'Removed from wishlist !!',
    addedToWishlist: 'Added to wishlist !!',
    subscribedSuccessfully: 'Subscribed successfully',
    alreadySubscribed: 'Already subscribed',
    messageIsRequired: 'Message is required',
    fullName: 'Full Name',
    email: 'Email',
    message: 'Message',
    queries: 'Queries',
    feedback: 'Feedback',
    queriesDescription:
        "Have questions about our vehicles or services? We're here to help with all your inquiries.",
    feedbackDescription:
        'Share your experience with us. Your feedback helps us improve our services.',
    getInTouchWithUs: 'Get In Touch With Us',
    phoneNumberVerifiedSuccess:
        'Phone number verified successfully, Please login.',
    verifyEmail:
        'Please verify your email for Auto24, Verification link has been sent to your email',
    sold: 'Sold',
    year: 'Year {{X}} and above',
    careers: 'Careers',
    discountOff: '{{X}} de Remise',
    ev: 'Electric',
    hybrid: 'Hybrid',
    phev: 'PHEV',
    carburant: 'Carburant',
    xlistingPageResultsTitle: '{{number}} Cars Found',
    filterBy: 'Filter By:',
    new: 'New',
    used: 'Used',
    popular: 'Popular',
    makes: 'Makes',
    carTypes: 'Car Types',
    explore: 'Explore',
    followUS: 'Follow Us',
    none: 'None',
    all: 'All',
    discount: 'Discount',
    financeYourCarWith: 'Finance Your Car With',
    creditButton: 'CREDIT GRATUIT',
    loanPaymentSimulator: 'Car Loan Calculator',
    loanPaymentContent:
        'We make it easy for you to own the car you want. Let us help you secure a loan from paperwork submission to getting fast loan approval.',
    loanCalculatorContent:
        'Monthly interest rate may differ as we partner with different finance institutions.',
    vehiclePrice: 'Vehicle price',
    noOfMonthlyPayments: 'Number of Monthly Payments',
    monthlyPaymentAmount: 'Monthly payment amount',
    // months: 'Months',
    creditRequestedAmount: 'Credit Requested Amount',
    overallCostOfCredit: 'Overall Credit',
    simulatorContribution: 'Simulator contribution',
    percentageOfContribution: 'Percentage of Contribution',
    applicationFees: 'Application fees',
    monthlyInsurance: 'Monthly insurance',
    noOfOwners: 'Number Of Owners',
    condition: 'Condition',
    maisonMere: 'Maison Mere',
    imported: 'Imported',
    tamperedOdometer: 'Tampered Odometer',
    carIssue: 'Car Issues',
    evaluateAgain: 'Evaluate Again',
    marketValue: 'Market Value',
    downloadAuto24App: 'Download the Auto24 App',
    browseMore: `Browse, buy, and sell with ease - your ultimate automotive companion`,
    saveTimeAndEffort: 'Save Time and Effort',
    saveTimeAndEffortSubtitle:
        'Let us save you valuable time as we handle everything, making selling effortless and stress-free.',
    freeNoCost: 'Free At No Cost',
    freeNoCostSubtitle: `Leave inspection, photography, transaction costs, and procedures to us - we've got you covered.`,
    competetivePrice: 'Competitive Price',
    competetivePriceSubtitle:
        'Get top price hassle-free with us; we manage all buyer communications and inquiries.',
    carTitle: `Car Details`,
    carDesc: `Provide us the information about your car`,
    personalDetail: `Personal Details`,
    personalDetailDesc: `Provide us the information about you`,
    sellCarHere: `Sell Car`,
    sellCarHereDesc: `You can get a perfect deal and we will post your car`,
    buySellUsedCar: 'Buy and sell used cars in',
    pressPage: {
        title: 'Auto24 Press',
        description1:
            'Auto24 has been recognised in different media around the world.',
        description2:
            'Auto24 has also been featured in conferences in Paris/France, Lisbon/Portugal, Barcelona/Spain, Sydney/Australia, London/UK, Kigali/Rwanda, Bangkok/Thailand, Abidjan/Ivory Coast, Johannesburg/South Africa, Dakar/Senegal, Nairobi/Kenya, Casablanca/Morocco…'
    },
    auto24Press: 'Auto24 Press',
    auto24PressDesc1:
        'Auto24 has been recognised in different media around the world.',
    auto24PressDesc2:
        'Auto24 has also been featured in conferences in Paris/France, Lisbon/Portugal, Barcelona/Spain, Sydney/Australia, London/UK, Kigali/Rwanda, Bangkok/Thailand, Abidjan/Ivory Coast, Johannesburg/South Africa, Dakar/Senegal, Nairobi/Kenya, Casablanca/Morocco…',
    mediaExposure: 'Our Media Exposure',
    mediaExposureDesc: 'Below is a selection of our media exposure.',
    press: 'Press',
    enterValidPhoneNumber: 'Enter Valid Phone Number',
    findUsGoogle: 'Find us on Google Map',
    locateUs: 'Locate Us',
    whereFindUs: 'Where to Find Us?',
    aroundLocationText: 'You can find us around these locations',
    facebook: 'Facebook',
    instagram: 'Instagram',
    tiktok: 'Tiktok',
    twitter: 'Twitter',
    youtube: 'Youtube',
    linkedin: 'LinkedIn',
    heroTitle:
        'Fast and easy way to <yellow>Buy</yellow> or <green>Sell</green> Cars',
    caRefundPolicy: 'Refund policy',
    caRefundPlicyDesc:
        'Hassle-free returns. Get a refund if you’re not satisfied.',
    caWarranty: 'Warranty',
    caWarrantyDesc:
        '6-month mechanical warranty on all non-wear and tear parts.',
    caInspectedDesc: 'Quality assured. Certified by a team of experts.',
    login: 'Login',
    wantToSellYourCar: 'Want to sell your car?',
    findUs: 'Find Us',
    featuredCars: 'Featured Cars',
    exploreCarByBodyType: 'Explore Car By Body Type ',
    searchByBrands: 'Search By Brands',
    loanSubtitle:
        'We do care about our customers and their happiness which encourage us to provide more services',
    perfectMatchYourBudget: 'Perfect Match For Your Budget',
    sellYourVehicle: 'Wish To Sell Your Vehicle?',
    sellYourVehicleSubtitle:
        'We do care about our customers and their happienes which encourage us to provide more services',
    sellMyCar: 'Sell my Car',
    blogTitleMobile: 'Look Before Buying',
    blogSubtitleMobile: 'Latest reads from auto24',
    readMore: 'Read More',
    opps: 'Oops!',
    noCarSection:
        'Looks like there are no listing in this segment. Would you like to request a car?',
    requestCar: 'Request Car',
    submitRequestFormSubtitle:
        'Submit a request, and we’ll help you find the perfect car tailored to your needs.',
    requestCarPageTitle: 'Discover the Car You’ve Been Searching For',
    requestCarPageSubtitle:
        'Let us know your preferences, and our team will work to find the ideal match for you. Submit your request today and get one step closer to driving your dream car.',
    viewAll: 'View All',
    inspection100: '100+ inspection points by our car experts',
    sixMonthWarranty:
        '6 months mechanoical warranty on all non-wear and tear parts',
    twoCarMaintenance: '2 car maintenance by Auto24 over 12 months',
    towingAndBreakdownAssistance: '12 months towing and breakdown assistance',
    multiCurrencyPayment: ' Multi-currency payment FCFA, €, $, £',
    fiveDaysMoneyBack: ' Multi-currency payment FCFA, €, $, £',
    vehiclesPaperWork: ' Vehicles paperwork are up to date and verified',
    verifyHistory: 'We verify history of all the vehicles we buy',
    buyBackOldCar: 'We buy back your old car',
    aboutCar: 'About Car',
    overview: 'Overview',
    carLoan: 'Car Loan',
    cars: 'Cars',
    note: 'Note',
    yourEstimatedMonthlyPayment: 'Your estimated monthly payment',
    applyFilter: 'Apply Filter',
    clearAll: 'Clear All',
    carsUnderPriceDescription:
        'Auto24 is your ultimate destination for exploring a wide variety of automobile brands from around the globe. Whether you’re in the market for a compact city car, a family-friendly SUV, or a luxury sedan, our platform connects you with options that cater to every need and preference. Each brand featured on Auto24 is renowned for its craftsmanship, technology, and reliability, giving you peace of mind in your search for the perfect vehicle.',
    fuelPriceTracker: 'Fuel Price Tracker',
    fuelPriceTrackerDesc:
        'Keep an eye on fuel prices with our easy-to-use Fuel Price Tracker! Get real-time updates on gas prices in your area, compare rates across different stations, and find the best deals near you. Save money and make smarter fueling decisions every time. Stay in control of your budget—track fuel prices today!',
    fuelPriceList: 'Fuel Price List',
    lastUpdateDate: 'Last Update Date',
    electricityPriceTracker: 'Electricity Price Tracker',
    electricityPriceTrackerDesc:
        'Electricity prices in {{ Country_name }} can fluctuate due to tariffs, load shedding, and energy demand. Our Electricity Price Tracker keeps you updated on the latest Eskom and electricity tariffs so you can manage your energy costs effectively.',
    electricityPriceList: 'Electricity Price List',
    currencyConverter: 'Currency Converter',
    currencyConverterDesc:
        "Stay updated with real-time exchange rates. Whether you're traveling, shopping online, or trading forex, our Currency Converter helps you get the best rates instantly.",
    liveExchangeRates: 'Live Exchange Rates',
    updatedAsOf: 'Updated as of',
    kmToMi: 'Kilometers to Miles',
    miToKm: 'Miles to Kilometers',
    kmToMiConverter: 'Kilometer to Miles Converter',
    miToKmConverter: 'Miles to Kilometer Converter',
    distanceConverterDesc:
        'Quickly and accurately convert miles to kilometers and vice versa—perfect for travel, driving, and everyday calculations!',
    tellUsYourFullName: 'Tell us your full name',
    tellUsYourEmailAddress: 'Tell us your email address',
    emailAddress: 'Email Address',
    mobileNumber: 'Mobile Number',
    tellUsWhatYouWant: 'Tell us what you want our help with',
    sendEnquiry: 'SEND ENQUIRY',
    referralSubmitted: 'Referral Submitted! Thank you for your referral.',
    mile: 'Mile',
    kilometer: 'Kilometer',
    howToConvert: 'How to convert {{ unit }}?',
    benin: 'Benin',
    coteDIvora: "Côte d'Ivoire",
    kenya: 'Kenya',
    southAfrica: 'South Africa',
    morocco: 'Morocco',
    rwanda: 'Rwanda',
    senegal: 'Senegal',
    tanzania: 'Tanzania',
    togo: 'Togo',
    uganda: 'Uganda',
    vehicleTaxCalculator: 'Vehicle Tax Calculator',
    topCarSales: 'Top New Cars Sales',
    drivingCostCalculator: 'Driving Cost Calculator',
    insuranceEstimator: 'Insurance Premium Estimator ',
    carLoanCalculator: 'Car Loan Calculator',
    exploreOtherTools: 'Explore Other Tools',
    drivingCostCalculatorDesc:
        "Understanding your driving costs is essential for budgeting and optimizing travel expenses. Whether you're commuting daily, embarking on a long road trip, or managing a fleet of vehicles, our Driving Cost Calculator helps you estimate fuel expenses accurately. Plan ahead, compare routes, and make cost-effective travel decisions with ease.",
    distance: 'Distance',
    fuelPrice: 'Fuel Price',
    enterFuelPrice: 'Enter fuel price',
    fuelEconomy: 'Fuel Economy',
    estimatedDrivingCost: 'Your estimated driving cost is',
    enterAllValues: 'Enter all values to calculate',
    startAddress: 'Start Address',
    endAddress: 'End Address',
    startAddressPlaceholder: 'Enter start address',
    endAddressPlaceholder: 'Enter end address',
    orEnterDistanceManually: 'Or enter distance manually',
    enterDistance: 'Enter distance',
    manualDistance: 'Manual distance',
    calculatedFromAddresses: 'Calculated from addresses',
    priceUpdatedFromAPI: 'Price updated from latest fuel price data',
    emissionEstimator: 'CO2 Emission Calculator',
    emissionEstimatorDesc:
        'Measure your impact on the environment and discover ways to reduce your carbon emissions across transportation, energy use, and daily habits. Take control of your sustainability efforts and contribute to a healthier planet.',
    estimatedEmission: 'Your estimated co2 emission is',
    emissionFactor: 'Emission Factor',
    efficiency: 'Efficiency',
    bestSellingCarsOfYear: 'Best-Selling Cars of {{ CurrentYear }}',
    discoverBestSellingCarsOfYear:
        'Discover the best-selling cars of {{ CurrentYear }}: A comprehensive look at global auto trends, top-selling models, and the rise of electric vehicles.',
    loanAmount: 'Loan Amount',
    carLoanCalculatorDesc:
        "Plan your next car purchase with confidence by calculating monthly repayments, total interest, and overall loan costs. Whether you're buying new or used, this tool helps you find a loan that fits your budget.",
    vehicleTechnicalDocuments: 'Vehicle Technical Documents',
    vehicleTechnicalDocumentsDesc:
        'Here are all the vehicles with their technical documents.',
    vehicleName: 'Vehicle Name',
    fileSize: 'File Size',
    modifiedDate: 'Modified Date',
    action: 'Action',
    downloadDoc: 'Download Document',
    technicalDocs: 'Technical Documents',
    dataNotAvailable: 'Records not available.',
    documentsAvailable: 'documents available',
    downloadError: 'Failed to Download',
    failedToDownload:
        'An error occurred while downloading the file. Please try again later or contact us for support.',
    close: 'Close',
    view: 'VIEW',
    openPdf: 'OPEN PDF',

    // MessagePlus
    mp_brand_ctaText: 'Chat with an Auto24 expert on WhatsApp',
    mp_brand_messageText: `Hello, I need support.`,
    mp_chatWidget_ctaText: 'Chat with an expert',
    mp_chatWidget_desktopText:
        'Chat with an AUTO24 expert on WhatsApp by scanning this QR code',
    mp_chatWidget_mobileText:
        'Chat with an AUTO24 expert on WhatsApp by clicking on this button',
    priceRangeList: 'Cars from {{min}} to {{max}}',
    comingCarsSubtitle: 'Here you can see different cars which is coming soon',
    buyComingCars: 'Incoming Cars',
    buyAllCars: 'All Cars',
    buyNewCars: 'New Cars',
    incoming: 'Incoming',
    referAndEarnPage: {
        title: 'Refer & Earn',
        hero: {
            title: 'Refer & Earn with Auto24',
            desc: 'Simply connect people who are looking to buy a car with Auto24 and get rewarded when your referral is successful. The programme is easy to join, free to use, and requires no upfront investment. You can refer as many customers as you like, track your referrals, and earn for every confirmed referral — with no limit on how much you can earn.'
        },
        howItWorks: {
            title: 'How It Works',
            desc: 'Refer potential car buyers to Auto24 and earn a reward when the referral is successful.\n\nAuto24 offers two referral options:',
            planA: {
                title: 'Plan A',
                desc: 'Refer a customer with complete supporting details and earn',
                amount: 'R2,500',
                per: '/per successful referral'
            },
            planB: {
                title: 'Plan B',
                desc: 'Refer a customer without supporting details and earn',
                amount: 'R1,000',
                per: '/per successful referral'
            },
            importantInfo: {
                title: 'Important Information',
                items: [
                    'You must register before submitting referrals',
                    'There is no registration fee',
                    'You can refer unlimited customers',
                    'Referrals can be submitted online',
                    'Rewards are paid only after the referral is successfully completed'
                ]
            }
        },
        getStarted: {
            title: 'How to Get Started?',
            steps: [
                {
                    title: 'Register',
                    desc: 'Sign up using the form below.'
                },
                {
                    title: 'Submit Referral',
                    desc: 'Enter the details of the customer you’re referring.'
                },
                {
                    title: 'We Contact Them',
                    desc: 'Auto24 reaches out to the referred customer.'
                },
                {
                    title: 'Get Paid',
                    desc: 'Receive your reward once the referral is confirmed.'
                }
            ],
            startReferring: {
                title: 'Start Referring Today',
                desc1: 'Fill in your details to receive more information and start earning with Auto24.',
                desc2: 'Terms and conditions apply.'
            }
        }
    },
    financePage: {
        financeHero: {
            title: '<yellow>Finance</yellow> Your <green>Car</green> With AUTO24',
            desc: "Financing your certified used car with AUTO24, c'est very simple and in 3 steps only:",
            step1: 'You choose your car',
            step2: 'You download all the documents required',
            step3: 'You wait for the pre approval from the bank',
            fastAndSimple: 'Fast and simple!',
            agent: 'One of our finance agents and advisor will take care of your file and guide you through the process.'
        },
        whyChooseUs: {
            title: 'Why Choose AUTO24',
            featureTitle1: 'Legacy of AUTO24',
            featureDesc1:
                "We've earned our place as the leading retailer of used cars across Africa, establishing a legacy built on years of exceptional service, customer satisfaction, and a focus on value.",
            featureTitle2: 'Rigorous Inspection',
            featureDesc2:
                'Our cars go through a rigorous 120-point inspection to guarantee you are purchasing a high-quality vehicle. From the engine to the upholstery, every detail is meticulously examined by our expert technicians.',
            featureTitle3: 'Unique Perks',
            featureDescItem1:
                "5-day Refund Policy: If you're unsatisfied with your purchase, our 5-day refund policy has you covered.",
            featureDescItem2:
                '6-Month Warranty: We provide a 6-month warranty on all our cars to ensure your peace of mind.',
            featureDescItem3:
                '1-Year Insurance Package: Drive safely with our 1-year insurance package.',
            featureDescItem4:
                '1-Year Maintenance Package: Relax, we offer a maintenance package for the first year of ownership',
            featureTitle4: 'Document Verification',
            featureDesc4:
                "All paperwork and vehicle history are thoroughly checked to ensure your asset's authenticity.",
            featureTitle5: 'Hassle-Free Trade-Ins',
            featureDesc5:
                'We offer quick and secure trade-ins and sales, making your experience as convenient as possible.'
        },
        qualitySection: {
            title: 'Quality, Trust, and Transparency',
            desc: "AUTO24 is more than a marketplace; it's a community where long-lasting trust is built. We aim to assist you in making informed decisions, offering an unrivaled experience you won't find elsewhere.",
            desc2: "Whether you're a first-time buyer or an experienced motorist, AUTO24 has something to offer you. Come explore the world of possibilities with us.",
            imageAlt: 'Trust and Partnership'
        },
        whyFinanceSection: {
            title: 'Why Finance Your Car With AUTO24',
            desc: 'We provide you the best financing offers with low interest and downpayments',
            featureTitle1: 'Competitive Rates',
            featureDesc1: 'APR From 5% (indicative)',
            featureTitle2: 'Flexible Durations',
            featureDesc2: 'Pay for your car in 12 to 72 monthly installments',
            featureTitle3: '100% Online Approach',
            featureDesc3: 'Sign all your documents at home'
        },
        ourFinancingPartnerSection: {
            title: 'Our Financing Partners',
            desc: 'Here are some of our financing partners'
        }
    },
    insureHero: {
        title: '<yellow>Insure</yellow> Your <green>Car</green> With AUTO24',
        desc: 'After purchasing your car, one of the most important step is to get the right insurance policy.',
        desc2: 'But with AUTO24 and our partner WiAssur, no more stress, it will be an easy and simple process. You’ll enjoy the best policy for yourself and your vehicle, at the best price.',
        desc3: 'One of our insurance agents and advisor will take care of your file and guide you through the process.'
    },
    aboutVehicle: 'About the Vehicle',
    getACallback: 'Get a Callback',
    vehicleRequirement: 'Vehicle Requirement',
    // Voetstoots Trade Sale translations
    voetstoots: 'Voetstoots',
    voetstootsTradeSaleTitle: 'Auto24 Trade Centre',
    voetstootsTradeSaleTitleRight: 'Trade Centre Stock',
    voetstootsTradeSaleSubtitle:
        'Buy trade cars as-is at discounted prices — no warranties, no returns.',
    voetstootsTradeSaleWarningDetails:
        'Auto24 Trade Centre cars are sold as-is, with no warranties, refunds, or repairs. Buyers accept full responsibility for inspections, roadworthiness, and future costs.',
    voetstootsTradeSaleList1: 'Sold voetstoots (as-is).',
    voetstootsTradeSaleList2: 'No warranties or guarantees apply.',
    voetstootsTradeSaleList3: "Repairs and breakdowns are buyer's cost.",
    voetstootsTradeSaleList4: 'No returns, refunds, or exchanges.',
    voetstootsTradeSaleList5: 'Roadworthy certificate not included.',
    voetstootsTradeSaleList6: 'Known issues disclosed, hidden faults possible.',
    voetstootsTradeSaleLearnMore: 'LEARN MORE',
    voetstootsTradeSaleCarsTitle: 'Trade Sale Cars',
    voetstootsTradeSaleCarsSubtitle:
        'Here you can see different cars from trade sale',
    voetstootsTradeSaleViewAll: 'VIEW ALL CARS',
    voetstootsTradeSalePageTitle: 'Trade Centre',
    voetstootsTradeSalePageDesc:
        'The Auto24 Trade Centre offers trade-in vehicles at discounted prices Voetstoots, meaning cars are sold with all faults, whether visible or hidden. No warranties, refunds, or repairs are included, and buyers accept full responsibility for any future costs or breakdowns. Unless otherwise stated, vehicles are sold without a roadworthy certificate, and while major known issues will be disclosed, hidden problems may still exist. Buyers are encouraged to inspect vehicles thoroughly before purchase. Transfer documents are provided after full payment.',
    voetstootsTradeSalePageKeywords:
        'voetstoots, trade sale, as-is cars, discounted vehicles, no warranty',
    whatsappBanner: {
        discover: 'Discover',
        exclusive: 'Exclusive',
        deals: 'Deals',
        stayUpdatedWithLatestNews:
            'Stay updated with the latest news, updates, and exclusive',
        offersStraightToWhatsApp: 'offers straight to your WhatsApp.',
        getLatestCarNewsAmazingTips:
            "Get the latest car news, amazing tips, and exclusive WhatsApp offers. Be the first to know about our best deals by following our channel – don't miss this opportunity!",
        joinChannel: 'JOIN CHANNEL'
    }
});

export default getCommonEnglish;
